import EnergyAnalyzerFilterInput from '@/components/forms/energyxplorer/EnergyAnalyzerFilterInput';

import InsetDrawer from '@/components/drawer/InsetDrawer';

const TreeGraphFilterInput = ({
  open,
  onClose,
  handleApply,
  selectedEnergyGroup,
}) => {
  return (
    <InsetDrawer
      open={open}
      onClose={onClose}
      title="Filtrer data"
      width={600}
      content={
        <EnergyAnalyzerFilterInput
          handleApply={handleApply}
          selectedEnergyGroup={selectedEnergyGroup}
          startHour={selectedEnergyGroup?.options?.workingDayStart}
          endHour={selectedEnergyGroup?.options?.workingDayEnd}
          setComparisonFilters={() => {}}
        />
      }
    />
  );
};

export default TreeGraphFilterInput;
